import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonsMenuModule } from '../../buttons/menu/buttons-menu.module';
import { FocusedModule } from './focused/focused.module';

import { JadFormFieldsSelectComponent } from './form-fields-select.component';
import { FormFieldsSelectRowModule } from './row/form-fields-select-row.module';

@NgModule({
  imports: [
    CommonModule,

    MatFormFieldModule,
    ReactiveFormsModule,
    TranslateModule,
    MatSelectModule,
    MatIconModule,
    MatTooltipModule,
    FocusedModule,
    ButtonsMenuModule
  ],
  declarations: [JadFormFieldsSelectComponent],
  exports: [JadFormFieldsSelectComponent, FormFieldsSelectRowModule]
})
export class JadFormFieldsSelectModule { }
